import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { ICustomCodeEnvironment } from '@scale/shared/types/config';

export type CodeBlockStore = {
  // For the CodeEditorWithExecution component to track read-only state
  childIdToReadOnlyState: Record<string, boolean>;
  setReadOnlyStateForChildId: (childId: string, readOnly: boolean) => void;

  // For the CodeEditorWithExecution component to track the selected custom code environment
  selectedCustomCodeEnvironment: Record<string, ICustomCodeEnvironment>;
  setSelectedCustomCodeEnvironment: (
    storeKey: string,
    customCodeEnvironment: ICustomCodeEnvironment,
  ) => void;
  getSelectedCustomCodeEnvironment: (storeKey: string) => ICustomCodeEnvironment;

  // For ExecutableCodeBlock component to track the open state of the scratchpad
  scratchpadOpenState: Record<string, boolean>;
  setScratchpadOpenState: (storeKey: string, open: boolean) => void;
  getScratchpadOpenState: (storeKey: string) => boolean;
};

export const useCodeBlockStore = create<CodeBlockStore>()(
  devtools((set, get) => ({
    childIdToReadOnlyState: {},
    setReadOnlyStateForChildId: (childId: string, readOnly: boolean) =>
      set(state => ({
        childIdToReadOnlyState: { ...state.childIdToReadOnlyState, [childId]: readOnly },
      })),

    selectedCustomCodeEnvironment: {},
    setSelectedCustomCodeEnvironment: (
      storeKey: string,
      customCodeEnvironment: ICustomCodeEnvironment,
    ) =>
      set(state => ({
        selectedCustomCodeEnvironment: {
          ...state.selectedCustomCodeEnvironment,
          [storeKey]: customCodeEnvironment,
        },
      })),
    getSelectedCustomCodeEnvironment: (storeKey: string) => {
      return get().selectedCustomCodeEnvironment[storeKey];
    },

    scratchpadOpenState: {},
    setScratchpadOpenState: (storeKey: string, open: boolean) =>
      set(state => ({
        scratchpadOpenState: { ...state.scratchpadOpenState, [storeKey]: open },
      })),
    getScratchpadOpenState: (storeKey: string) => {
      return get().scratchpadOpenState[storeKey] ?? false;
    },
  })),
);
